export const USB_VENDOR_IDS = {
    CH340: 0x1a86,
    ESPRESSIF: 0x303a,
    PLODE: 0xb1b0,
}

export const USB_PRODUCT_IDS = {
    CH340_SERIAL: 0x7523,
    ESP32_S_SERIAL: 0x1001,
    CH340_8040: 0x8040,
    POKI: 0x8055,
    TOKI: 0x8056,
    ZING: 0x8057,
    CRAWLEE: 0x8058,
    KLAW: 0x8059,
}

export const SERIAL_PORT_FILTERS = [
    {
        usbVendorId: USB_VENDOR_IDS.CH340,
        usbProductId: USB_PRODUCT_IDS.CH340_SERIAL,
    },
    {
        usbVendorId: USB_VENDOR_IDS.ESPRESSIF,
        usbProductId: USB_PRODUCT_IDS.ESP32_S_SERIAL,
    },
    {
        usbVendorId: USB_VENDOR_IDS.CH340,
        usbProductId: USB_PRODUCT_IDS.CH340_8040,
    },
    {
        usbVendorId: USB_VENDOR_IDS.PLODE,
        usbProductId: USB_PRODUCT_IDS.POKI,
    },
    {
        usbVendorId: USB_VENDOR_IDS.PLODE,
        usbProductId: USB_PRODUCT_IDS.TOKI,
    },
    {
        usbVendorId: USB_VENDOR_IDS.PLODE,
        usbProductId: USB_PRODUCT_IDS.ZING,
    },
    {
        usbVendorId: USB_VENDOR_IDS.PLODE,
        usbProductId: USB_PRODUCT_IDS.CRAWLEE,
    },
    {
        usbVendorId: USB_VENDOR_IDS.PLODE,
        usbProductId: USB_PRODUCT_IDS.KLAW,
    },
]

export const FIRMWARE_PORT_FILTERS = SERIAL_PORT_FILTERS

export const getDeviceProductIds = (device) =>
    Array.isArray(device?.usbProductIds)
        ? device.usbProductIds
        : device?.usbProductId != null
          ? [device.usbProductId]
          : []

export const deviceMatchesPid = (device, pid) =>
    getDeviceProductIds(device).some((id) => id == pid)
